import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import HomePage from "./pages/HomePage";
import NewsDetailPage from "./pages/NewsDetailPage";
import AboutUsPage from "./pages/AboutUsPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { LanguageProvider } from "./context/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ApiPinger = () => {
  useEffect(() => {
    const helloWorldApi = async () => {
      try {
        const response = await axios.get(`${API}/`);
        // Log only once on mount to verify backend connectivity
        console.log("Backend health:", response.data.message);
      } catch (e) {
        console.warn("Backend API /api/ not reachable yet", e?.message || e);
      }
    };

    helloWorldApi();
  }, []);

  return null;
};

function App() {
  return (
    <div className="App text-foreground">
      <BrowserRouter>
        <LanguageProvider>
          <ApiPinger />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/news/:slug" element={<NewsDetailPage />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
